import { render } from "./messaging.vue?vue&type=template&id=021e567b"
import script from "./messaging.vue?vue&type=script&lang=js"
export * from "./messaging.vue?vue&type=script&lang=js"

import "./messaging.vue?vue&type=style&index=0&id=021e567b&lang=css"
script.render = render

export default script